var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"100%"}},[_c('div',{staticClass:"title text-center"},[_vm._v("Maintenance Details")]),_c('maintenance-show',{attrs:{"maintenance-id":this.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }